<template>
  <div class="display-1 text-center justify-content-center font-weight-bold">
    404 SORRY COULDN'T FIND IT!!!
    <img src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/bc70c43b-aeca-448a-a158-0f8e7c281a0d/dceqwb1-a75b8ac9-8340-45bb-8049-4883b81baa3c.gif?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOiIsImlzcyI6InVybjphcHA6Iiwib2JqIjpbW3sicGF0aCI6IlwvZlwvYmM3MGM0M2ItYWVjYS00NDhhLWExNTgtMGY4ZTdjMjgxYTBkXC9kY2Vxd2IxLWE3NWI4YWM5LTgzNDAtNDViYi04MDQ5LTQ4ODNiODFiYWEzYy5naWYifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6ZmlsZS5kb3dubG9hZCJdfQ.vb22ieb2ozkCYf4rYIihVZXu1zqC943b9kBTrrL069I">
  </div>
</template>
<script>
export default {
  name: 'NotFound'
};
</script>